import { UserManagerSettings } from "oidc-client-ts";
export interface oiauthAuthData {
    client_id: string
    client_secret: string
}

export const baseOiauth: UserManagerSettings = {
    authority: "https://sso2.doctorprox.com:6040/realms/futurecare/",
    client_id: "dr-prox",
    redirect_uri: `${window.location.origin}/signin-callback`,
    silent_redirect_uri: `${window.location.origin}/signin-silent-callback`,
    post_logout_redirect_uri: `${window.location.origin}`,
    client_secret: "MC9elj8r9akse5nDitgF4jzH03g6A7VG",
    response_type: "code",
    scope: "openid profile dr",
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTimeInSeconds: 60
};
export const getDataOiauth = () : UserManagerSettings =>{
    const hostname = window.location.hostname;  
    const hostnameSplited = hostname.split(".");
    const newOauthAuthData = baseOiauth;
    if (hostnameSplited.length > 0) {
        switch (hostnameSplited[0]) {
            case "drgyc":
            case "gyc":
                newOauthAuthData.client_id = "gyc-dr-prox";
                newOauthAuthData.client_secret = "pYXPpPi5ZScawY1bAgGVM5xlORpv01kb";
                break;
            case "drmpc":
            case "mpc":
                newOauthAuthData.client_id = "mpc-dr-prox";
                newOauthAuthData.client_secret = "6CaNilMN7nj4ICv5b3NQG8Kdu8GXS1Lf";
                break;
            case "drcentromater":
            case "centromater":
                newOauthAuthData.client_id = "centromater-dr-prox";
                newOauthAuthData.client_secret = "VBp5sDJ9aeHbD03xOUhoVoV8FHDsNhew";
                break;
            case "drhubio":
            case "hubio":
                newOauthAuthData.client_id = "hubio-dr-prox";
                newOauthAuthData.client_secret = "rpOJALgcWxRhZjk6SxFxurSIehwbWs6J";
                break;
            case "drschiller":
            case "schiller":
                newOauthAuthData.client_id = "schiller-americas-dr-prox";
                newOauthAuthData.client_secret = "mreH0LjdR19FttZmZOLuihpgCN59IPAC";
                break;
            default:
                break;
        }
    }
    return newOauthAuthData;
};  

 export const oiauth = getDataOiauth();
